import { useTheme } from '@mui/material';
interface CorrectType {
  size?: number,
}

const Correct = ({ size = 318 }: CorrectType) => {
  const theme = useTheme();
  return (
    <svg
      width={size + 1}
      height={size}
      viewBox={`0 0 ${size + 1} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_596_8851)">
        <path
          d="M137.318 306L308.306 184.519C310.039 175.324 311 165.836 311 156.143C311 72.4571 243.274 4.61822 159.727 4.61821C76.1807 4.6182 8.45452 72.4571 8.45451 156.143C8.4545 232.197 64.3925 295.155 137.318 306Z"
          fill="#31A54C"
        />
        <path
          d="M305 156.143C305 164.614 304.235 172.935 302.836 181.045L135.835 299.693C66.9728 288.285 14.4545 228.363 14.4545 156.143C14.4545 75.7613 79.5038 10.6182 159.727 10.6182C239.951 10.6182 305 75.7614 305 156.143Z"
          stroke={`${theme.palette.primary.main ?? '#9BCAFF'}`}
          stroke-width="12"
        />
      </g>
      <path
        d="M237.364 154.727C237.364 111.922 202.545 77.0911 159.728 77.0911C116.922 77.0911 82.0915 111.911 82.0915 154.727C82.0915 197.544 116.911 232.364 159.728 232.364C202.545 232.364 237.364 197.533 237.364 154.727ZM213.868 154.727C213.868 184.579 189.58 208.867 159.728 208.867C129.876 208.867 105.588 184.579 105.588 154.727C105.588 124.876 129.876 100.588 159.728 100.588C189.58 100.588 213.868 124.876 213.868 154.727Z"
        fill="white"
        stroke="white"
        stroke-width="4"
      />
      <path
        d="M143.208 284.443C166.87 215.233 237.326 174.982 308.673 185.469L223.146 245.734L137.618 306C138.921 298.786 140.756 291.589 143.208 284.443Z"
        fill={`${theme.palette.primary.main ?? '#9BCAFF'}`}
      />
      <defs>
        <filter
          id="filter0_d_596_8851"
          x="0.45459"
          y="0.618164"
          width="318.545"
          height="317.382"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_596_8851"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_596_8851"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Correct;
